module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/more-topic-2.b1a6d07e.mp4";